import React from 'react';
import ReactDOM from 'react-dom';
import ajax from 'sma.common/ajax';
import modals from 'sma.common/components/modals';

import ReviewsTable from './reviewsTable/table';
import getComponentWithTheme from '../themeProvider';

class ReviewerAssignments extends Backbone.View {
	get events() {
		return {
			'click .sma-js-submit-reviews': 'submitModal',
			'click .sma-js-reopen-reviews': 'reopenModal',
			'click .sma-js-reviewer-instructions': 'instructionsModal',
			'change #sma-js-subround-select': 'changeSubRound',
		};
	}

	initialize(config) {
		this.config = config;
		this.setElement('body');
		this.renderTable();
	}

	instructionsModal(e) {
		e.preventDefault();

		ajax.get({
			url: $(e.currentTarget).data('url'),
			callback: (response) => {
				const content = $('<div></div>')
					.html(response.instructions || gettext('There are no instructions for this stage.'));

				/* eslint-disable no-new */
				new modals.ContentModal(content, {
					destroyOnClose: true,
					autoShow: true,
					title: gettext('Instructions'),
				});
				/* eslint-enable no-new */
			},
		});
	}

	submitModal() {
		const modal = new sma.components.modals.AjaxFormModal({
			size: 'md',
			buttons: [{
				label: gettext('CANCEL'),
				cls: 'btn-link',
				handler: (handlerModal) => {
					handlerModal.hide(true);
				},
			}, {
				label: gettext('SUBMIT'),
				cls: 'btn-primary',
				handler: (handlerModal) => {
					const form = handlerModal.modalBody.find('form');
					form.submit();
				},
			}],
		});

		modal.addToStack(
			gettext('Submit'),
			new sma.components.modals.AjaxFormContent(reverse('reviewers-assignments-submit', {
				award_id: this.config.awardId,
				round_id: this.config.objectId,
			}), {
				title: gettext('Submit reviews'),
				onLoad: () => {
					modal.show();
				},
			}),
		);
	}

	reopenModal() {
		const text = gettext('Are you sure you want to reopen your reviews?');

		/* eslint-disable no-new */
		new sma.components.modals.Confirm(
			gettext('Reopen reviews'),
			`<i class="nc-icon-mini ui-3_alert"></i> ${text}`,
			() => {
				sma.ajax.post({
					noSuccessAlert: false,
					url: reverse('reviewers-assignments-reopen', {
						award_id: this.config.awardId,
						round_id: this.config.objectId,
					}),
					callback: () => {
						setTimeout(() => {
							window.location.reload();
						}, 2000);
					},
				});
			},
			{
				yes: gettext('REOPEN'),
				no: gettext('CANCEL'),
			},
		);
		/* eslint-enable no-new */
	}

	changeSubRound(e) {
		window.location = reverse('reviewers-assignments-list', {
			award_id: this.config.awardId,
			round_id: e.target.value,
		});
	}

	renderTable() {
		/* eslint-disable react/jsx-filename-extension */
		ReactDOM.render(
			getComponentWithTheme(
				<ReviewsTable
					allowConflicts={this.config.allowConflicts}
					applicantStages={this.config.applicantStages}
					awardId={this.config.awardId}
					canEdit={this.config.canEdit}
					completeBeforeSubmit={this.config.completeBeforeSubmit}
					data={this.config.data}
					reviewerSubmitted={this.config.reviewerSubmitted}
					roundId={this.config.objectId}
					userId={this.config.userId}
				/>,
				window.LOCALE.theme,
			),
			this.config.table.container,
		);
		/* eslint-enable react/jsx-filename-extension */
	}
}

module.exports = ReviewerAssignments;
